import React, { useContext } from "react";
import "./ProductDisplay.css";
import star_icon from "../Assets/star_icon.png";
import { ShopContext } from "../../Context/ShopContext";

const ProductDisplay = (props) => {
  const { product } = props;
  const { addToCart } = useContext(ShopContext);

  return (
    <div className="productdisplay">
      <div className="productdisplay-left">
        <div className="productdisplay-img-list">
          {product.images.map((image, index) => (
            <img key={index} src={image} alt={`Product ${index + 1}`} />
          ))}
        </div>
        <div className="productdisplay-img">
          <img
            className="productdisplay-main-img"
            src={product.images[0]}
            alt="Main Product"
          />
        </div>
      </div>
      <div className="productdisplay-right">
        <h1>{product.name}</h1>
        <div className="productdisplay-right-stars">
          <img src={star_icon} alt="Star" />
          <img src={star_icon} alt="Star" />
          <img src={star_icon} alt="Star" />
          <img src={star_icon} alt="Star" />
          <img src={star_icon} alt="Star" />
          <p>(122)</p>
        </div>
        <div className="productdisplay-right-prices">
          <div className="productdisplay-right-price-old">R${product.old_price}</div>
          <div className="productdisplay-right-price-new">R${product.new_price}</div>
        </div>
        <div className="productdisplay-right-description">
          Produto de crochê feito à mão, com alta qualidade e durabilidade.
        </div>
        <div className="productdisplay-right-size">
          <h1>Selecione o Tamanho</h1>
          <div className="productdisplay-right-size-options">
            <div>S</div>
            <div>M</div>
            <div>L</div>
            <div>XL</div>
            <div>XXL</div>
          </div>
        </div>
        <button onClick={() => addToCart(product.id)}>
          ADICIONAR AO CARRINHO
        </button>
        <p className="productdisplay-right-category">
          <span>Categoria :</span> {product.category}
        </p>
        <p className="productdisplay-right-category">
          <span>Tags :</span> Moderno, Últimas tendências
        </p>
      </div>
    </div>
  );
};

export default ProductDisplay;
